/**
 * Patient API Service
 * Handles all patient-related API calls
 */

import { post, get, patch } from './client';

export const patientApi = {
  /**
   * Get all patients (for doctors)
   */
  getAll: async () => {
    return get('/api/patients');
  },

  /**
   * Get patient's own notes (for patients)
   */
  getMyNotes: async () => {
    return get('/api/patients/my-notes');
  },

  /**
   * Claim account (links patient record to current user by email)
   */
  claimAccount: async () => {
    return post('/api/patients/claim-account', {});
  },

  /**
   * Create new patient
   */
  create: async (patientData) => {
    return post('/api/patients', patientData);
  },

  /**
   * Update patient
   */
  update: async (patientId, patientData) => {
    return patch(`/api/patients/${patientId}`, patientData);
  },
};
